const he = {
  translation: {
    main_title_dogs: "גינת הכלבים של אופיר",
    main_title_cats: "גינת החתולים של אופיר",
    select_breed_dogs: "בחר גזע כלבים...",
    select_breed_cats: "בחר גזע חתולים...",
    all_breeds_dogs: "כל הגזעים (אקראי)",
    all_breeds_cats: "כל הגזעים (אקראי)",
    search_breeds: "חיפוש גזע...",
    no_results: "לא נמצאו תוצאות",
    loading_dogs: "טוען חברים מתוקים...",
    loading_cats: "טוען חתלתולים חמודים...",
    error_loading_dogs: "אופס! לא הצלחנו להביא את הכלבלבים.",
    error_loading_cats: "אופס! לא הצלחנו להביא את החתלתולים.",
    tab_dogs: "כלבים 🐶",
    tab_cats: "חתולים 🐱",

    // Breed Translations (Main breeds)
    affenpinscher: "אפנפינשר",
    african: "אפריקאי",
    airedale: "איירדייל",
    akita: "אקיטה",
    appenzeller: "אפנזלר",
    australian: "רועה אוסטרלי",
    basenji: "בסנג'י",
    basset: "באסט",
    beagle: "ביגל",
    bluetick: "בלוטיק",
    borzoi: "בורזוי",
    bouvier: "בוויה דה פלנדר",
    boxer: "בוקסר",
    brabancon: "ברבנקון",
    briard: "בריארד",
    buhund: "בוהונד",
    bulldog: "בולדוג",
    bullterrier: "בולטרייר",
    cattledog: "כלב בקר",
    cavapoo: "קאוואפו",
    chihuahua: "צ'יוואווה",
    chow: "צ'או",
    clumber: "קלאמבר",
    cockapoo: "קקפו",
    collie: "קולי",
    coonhound: "קונהאונד",
    corgi: "קורגי",
    dachshund: "תחש",
    dalmatian: "דלמטי",
    dane: "דני",
    dhole: "דול",
    dingo: "דינגו",
    doberman: "דוברמן",
    elkhound: "אלקהאונד",
    entlebucher: "אנטלבוכר",
    eskimo: "אסקימו",
    frise: "פריזה",
    german: "רועה גרמני",
    greyhound: "גרייהאונד",
    husky: "האסקי סיבירי",
    labrador: "לברדור",
    leonberg: "לאונברג",
    malamute: "מלמוט",
    malinois: "מלינואה",
    maltese: "מלטז",
    mastiff: "מסטיף",
    papillon: "פפיון",
    pekinese: "פקינזי",
    pembroke: "פמברוק",
    pinscher: "פינצ'ר",
    pitbull: "פיטבול",
    pointer: "פוינטר",
    pomeranian: "פומרניאן",
    poodle: "פודל",
    pug: "פאג",
    pyrenees: "פירנאי",
    retriever: "רטריבר",
    ridgeback: "רידג'בק",
    rottweiler: "רוטוויילר",
    saluki: "סלוקי",
    samoyed: "סמוייד",
    schnauzer: "שנאוצר",
    setter: "סתר",
    sharpei: "שארפיי",
    sheepdog: "כלב רועים",
    shiba: "שיבה אינו",
    shihtzu: "שיצו",
    spaniel: "ספנייל",
    spitz: "שפיץ",
    springer: "ספרינגר",
    stbernard: "סן ברנרד",
    terrier: "טרייר",
    vizsla: "ויז'לה",
    weimaraner: "ויימרנר",
    whippet: "וויפט",
    wolfhound: "כלב זאב",

    // Sub-breed combined translations
    "african/wild": "כלב בר אפריקאי",
    "australian/shepherd": "רועה אוסטרלי",
    "buhund/norwegian": "בוהונד נורווגי",
    "bulldog/boston": "בוסטון בולדוג",
    "bulldog/english": "בולדוג אנגלי",
    "bulldog/french": "בולדוג צרפתי",
    "bullterrier/staffordshire": "סטפורדשייר בול טרייר",
    "cattledog/australian": "כלב בקר אוסטרלי",
    "collie/border": "בורדר קולי",
    "corgi/cardigan": "קארדיגן קורגי",
    "dane/great": "דני ענק",
    "deerhound/scottish": "דירהאונד סקוטי",
    "elkhound/norwegian": "אלקהאונד נורווגי",
    "frise/bichon": "בישון פריזה",
    "german/shepherd": "רועה גרמני",
    "greyhound/italian": "גרייהאונד איטלקי",
    "hound/afghan": "אפגני האונד",
    "hound/basset": "באסט האונד",
    "hound/blood": "בלדהאונד",
    "hound/english": "האונד אנגלי",
    "hound/ibizan": "איביזן האונד",
    "mastiff/bull": "בולמסטיף",
    "mastiff/english": "מסטיף אנגלי",
    "mastiff/tibetan": "מסטיף טיבטי",
    "pinscher/miniature": "פינצ'ר מיניאטורי",
    "poodle/miniature": "פודל מיניאטורי",
    "poodle/standard": "פודל סטנדרטי",
    "poodle/toy": "פודל טוי",
    "retriever/golden": "גולדן רטריבר",
    "retriever/flatcoated": "פלאטקוטד רטריבר",
    "retriever/curly": "קארלי רטריבר",
    "schnauzer/miniature": "שנאוצר מיניאטורי",
    "schnauzer/giant": "שנאוצר ענק",
    "spaniel/cocker": "קוקר ספניאל",
    "spaniel/welsh": "וולש ספניאל",
    "terrier/american": "אמריקן טרייר",
    "terrier/yorkshire": "יורקשייר טרייר",
    "terrier/toy": "טוי טרייר",
    "terrier/scottish": "טרייר סקוטי",
    "terrier/irish": "טרייר אירי",
    "terrier/fox": "פוקס טרייר",
    "terrier/boston": "בוסטון טרייר",
    "terrier/american staffordshire": "אמריקן סטפורדשייר טרייר",
    "wolfhound/irish": "וולפהאונד אירי",

    // Cat Breeds
    abys: "אביסיני",
    aege: "אגאי",
    abob: "בובטייל אמריקאי",
    acur: "אמריקן קורל",
    asho: "אמריקאי קצר שיער",
    awir: "אמריקאי מקורזל שיער",
    amau: "מאו ערבי",
    amis: "אוסטרליאן מיסט",
    bali: "בלינזי",
    bamb: "במבינו",
    beng: "בנגלי",
    birm: "בירמן",
    bomb: "בומביי",
    bslo: "בריטי ארוך שיער",
    bsho: "בריטי קצר שיער",
    bure: "בורמזי",
    buri: "בורמילה",
    cspa: "קליפורניה ספנגלד",
    ctif: "שאנטילי-טיפאני",
    char: "שארטרו",
    chau: "צ'אוסי",
    chee: "צ'יטו",
    csho: "קולורפוינט קצר שיער",
    crex: "קורניש רקס",
    cymr: "סימריק",
    cypr: "קפריסאי",
    drex: "דבון רקס",
    dons: "דונסקוי",
    lihu: "דרגון לי",
    emau: "מאו מצרי",
    ebur: "בורמזי אירופאי",
    esho: "אקזוטי קצר שיער",
    hbro: "הוואנה בראון",
    hima: "הימלאיה",
    jbob: "בובטייל יפני",
    java: "ג'וואנז",
    khao: "קאו מאני",
    kora: "קוראט",
    kuri: "קוריליאן",
    lape: "לה-פרם",
    mcoo: "מיין קון",
    mala: "מלאי",
    manx: "מנקס",
    munc: "מנצ'קין",
    nebe: "נבלונג",
    norw: "חתול יער נורווגי",
    ocic: "אוסיקט",
    orie: "אוריינטלי",
    pers: "פרסי",
    pixi: "פיקסי-בוב",
    raga: "ראגאמאפין",
    ragd: "ראגדול",
    rblu: "רוסי כחול",
    sava: "סוואנה",
    sfol: "סקוטיש פולד",
    srex: "סלקירק רקס",
    siam: "סיאמי",
    sibe: "סיבירי",
    sing: "סינגפורה",
    snow: "סנואושו",
    soma: "סומלי",
    sphy: "ספינקס",
    tonk: "טונקינז",
    toyg: "טויגר",
    tang: "אנגורה טורקית",
    tvan: "ואן טורקי",
    ycho: "יורק שוקולד",
  },
};

export default he;
